import * as PopoverPrimitive from "@radix-ui/react-popover";
import { ForwardedRef, forwardRef } from "react";
import { PiXCircle } from "react-icons/pi";

import { cn } from "../../lib/utils";

function Popover(props: PopoverPrimitive.PopoverProps) {
  return <PopoverPrimitive.Root {...props} />;
}

type PopoverContentType = PopoverPrimitive.PopoverContentProps &
  PopoverPrimitive.PopoverPortalProps & {
    showClose?: boolean;
    showArrow?: boolean;
    arrowClassName?: string;
    containerClassName?: string;
  };

export function PopoverContent(
  {
    children,
    containerClassName,
    className,
    sideOffset = 4,
    container,
    showClose,
    showArrow = true,
    arrowClassName,
    ...props
  }: PopoverContentType,
  ref: ForwardedRef<HTMLDivElement>
) {
  const offset = showArrow ? 0 : sideOffset;

  return (
    <PopoverPrimitive.Portal container={container}>
      <PopoverPrimitive.Content
        ref={ref}
        sideOffset={offset}
        className={cn(
          "relative min-w-[var(--radix-popover-trigger-width)] max-h-[var(--radix-popover-content-available-height)] rounded-md border-primary bg-background z-50 shadow shadow-black/50",
          "data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=closed]:animate-out data-[state=closed]:fade-out-0",
          "data-[side=bottom]:slide-in-from-top-4 data-[side=bottom]:slide-out-to-top-4",
          "data-[side=top]:slide-in-from-bottom-4 data-[side=top]:slide-out-to-bottom-4",
          "data-[side=right]:slide-in-from-left-4 data-[side=right]:slide-out-to-left-4",
          "data-[side=left]:slide-in-from-right-4 data-[side=left]:slide-out-to-right-4",
          showArrow
            ? "data-[side=bottom]:border-t-4 data-[side=top]:border-b-4 data-[side=right]:border-l-4 data-[side=left]:border-r-4"
            : "border",
          containerClassName
        )}
        {...props}
      >
        {showArrow && (
          <PopoverPrimitive.Arrow asChild>
            <div className={cn("-translate-y-3 bg-white border-r-4 border-b-4 border-primary w-6 h-6 rotate-45", arrowClassName)} />
          </PopoverPrimitive.Arrow>
        )}
        <div className={cn("w-full relative bg-white rounded-md p-2", className)}>
          {showClose && (
            <PopoverPrimitive.Close className="absolute right-2 top-2">
              <PiXCircle className="w-6 h-6 hover:text-primary" />
            </PopoverPrimitive.Close>
          )}
          {children}
        </div>
      </PopoverPrimitive.Content>
    </PopoverPrimitive.Portal>
  );
}
export const PopoverTrigger = PopoverPrimitive.Trigger;
Popover.Trigger = PopoverTrigger;
Popover.Content = forwardRef(PopoverContent);
export default Popover;
